(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["a-general-discount-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('l-discount-code')) {
		class LTADiscountCode extends HTMLElement {
			constructor() {
				super()

				this.handleCTAClick = this.handleCTAClick.bind(this)
			}

			connectedCallback() {
				this.CTAEl = this.querySelector('[data-cta]')
				if (this.CTAEl) {
					this.CTAEl.addEventListener('click', this.handleCTAClick)
				}
			}

			handleCTAClick(event) {
				event.preventDefault()

				const cta = this.CTAEl?.dataset?.cta

				if (cta) {
					navigator.clipboard.writeText(cta).then(() => {
						this.CTAEl.classList.add('is-copied')
						setTimeout(() => {
							this.CTAEl.classList.remove('is-copied')
						}, 3000)
					})
				}
			}
		}

		customElements.define('l-discount-code', LTADiscountCode)
	}
  } catch(e) { console.error(e); }
})();

})();
